import { render, staticRenderFns } from "./add-document-popup.vue?vue&type=template&id=51b9cb5e"
import script from "./add-document-popup.vue?vue&type=script&lang=js"
export * from "./add-document-popup.vue?vue&type=script&lang=js"
import style0 from "./add-document-popup.vue?vue&type=style&index=0&id=51b9cb5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports